import Link from 'next/link';
import styled, { Box } from '@xstyled/styled-components';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import ClientOnly from '@/UI/Primitives/ClientOnly';

const Crumbs = styled(FlexBox)`
  flex-wrap: wrap;

  a {
    color: #959595;
    &:hover {
      color: gray-300;
    }
  }

  span {
    position: relative;
    bottom: 0.2rem;
  }
`;

export default function BreadCrumbs({ crumbs }) {
  return (
    <Box display={{ _: 'none', desktop: 'inline' }}>
      <ClientOnly>
        <Crumbs spaceX={10}>
          {crumbs?.map((crumb, i) => {
            return (
              <Box spaceX={10} key={crumb.path}>
                {i > 0 && (
                  <span role="img" aria-label="Sequence arrow">
                    {SequenceArrow}
                  </span>
                )}
                <Link href={crumb.path}>
                  <a>{crumb.name}</a>
                </Link>
              </Box>
            );
          })}
        </Crumbs>
      </ClientOnly>
    </Box>
  );
}

const SequenceArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.114"
    height="4.48"
    viewBox="0 0 9.114 4.48"
  >
    <path
      id="Icon_awesome-long-arrow-alt-right"
      data-name="Icon awesome-long-arrow-alt-right"
      d="M6.387,11.684H.244A.244.244,0,0,0,0,11.929v1.139a.244.244,0,0,0,.244.244H6.387v.937a.488.488,0,0,0,.834.345l1.751-1.751a.488.488,0,0,0,0-.691L7.22,10.4a.488.488,0,0,0-.834.345Z"
      transform="translate(0 -10.258)"
      fill="#959595"
    />
  </svg>
);
